module.exports = __webpack_public_path__ + "media/images/icon/navigation/market-0ca8a2811803eb40da672da8769fbe5f.svg";